import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en/translation.json';
import heTranslations from '../locales/he/translation.json';
import arTranslations from '../locales/ar/translation.json';
import ruTranslations from '../locales/ru/translation.json';
import elTranslations from '../locales/el/translation.json';
import plTranslations from '../locales/pl/translation.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  he: {
    translation: heTranslations,
  },
  ar: {
    translation: arTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  el: {
    translation: elTranslations,
  },
  pl: {
    translation: plTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
